
/* injects from baggage-loader */

'use strict';

import PageEightComponent from './page-eight.component';

const PageEightModule = angular.module('page-eight-module', [
  'ui.router'
])
  .config($stateProvider => {
    'ngInject';

    $stateProvider
      .state('page-eight', {
        url: '/page-eight',
        views:{
          "@":{
            component: 'pageEight'
          }
        }
      });
  })
  .component('pageEight', new PageEightComponent());

export default PageEightModule;



// WEBPACK FOOTER //
// ./src/app/pages/page-eight/page-eight.module.js